import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUser from '../_reducers/user';

export const selectUserState = createFeatureSelector<fromUser.UserState>('users');

export const selectAllUsers = createSelector(selectUserState, fromUser.selectAll);

export const selectUserEntities = createSelector(selectUserState, fromUser.selectEntities);

export const selectUserById = (id: number) =>
  createSelector(selectUserEntities, (entities) => entities[id]);

export const selectUserTotal = createSelector(selectUserState, fromUser.selectTotal);
